export const ContactIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_52681)">
        <path
          d="M13.4758 11.3544C13.5623 11.2968 13.6619 11.2617 13.7654 11.2523C13.869 11.2429 13.9732 11.2594 14.0688 11.3005L17.7531 12.9512C17.8773 13.0043 17.9809 13.0962 18.0485 13.2131C18.1161 13.3299 18.1441 13.4656 18.1281 13.5997C18.0067 14.5067 17.5601 15.3389 16.8711 15.9413C16.1822 16.5437 15.298 16.8754 14.3828 16.8747C11.5649 16.8747 8.86238 15.7553 6.8698 13.7627C4.87723 11.7701 3.75781 9.0676 3.75781 6.24968C3.75711 5.33452 4.08881 4.45026 4.69122 3.76134C5.29363 3.07242 6.12574 2.62574 7.03281 2.50436C7.1669 2.48844 7.30254 2.51636 7.41943 2.58396C7.53633 2.65156 7.62818 2.7552 7.68125 2.87936L9.33203 6.56686C9.37259 6.66157 9.38911 6.76484 9.38011 6.86748C9.37112 6.97012 9.33689 7.06894 9.28047 7.15515L7.61094 9.1403C7.55172 9.22966 7.5167 9.33286 7.5093 9.43981C7.50191 9.54676 7.52239 9.6538 7.56875 9.75046C8.21484 11.0731 9.58203 12.4239 10.9086 13.0637C11.0058 13.1099 11.1133 13.1299 11.2206 13.1218C11.3278 13.1138 11.4312 13.0778 11.5203 13.0176L13.4758 11.3544Z"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_52681">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.632812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
